'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapValues = require('lodash/fp/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var mapValuesWithKey = _mapValues2.default.convert({ cap: false });
var queueHandlersAfter = mapValuesWithKey(function (handler, name) {
  return function (props) {
    return function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!props[name]) {
                  _context.next = 6;
                  break;
                }

                _context.t0 = handler(props);
                _context.next = 4;
                return props[name].apply(props, _args);

              case 4:
                _context.t1 = _context.sent;
                return _context.abrupt('return', (0, _context.t0)(_context.t1));

              case 6:
                return _context.abrupt('return', handler(props).apply(undefined, _args));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();
  };
});

exports.default = queueHandlersAfter;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/queueHandlersAfter.js
// module id = 1249
// module chunks = 0